import { useQuery } from "@tanstack/react-query";
import { container } from "tsyringe";
import { ViewService } from "../view.service";

export const getDeliveryContext = async (routeIds?: string[]) => {
  if (!routeIds) {
    return Promise.resolve(null);
  }
  const viewService = container.resolve(ViewService);
  const tasks = routeIds.map((routeId) =>
    viewService.getDeliveryContext(routeId)
  );

  return Promise.all(tasks);
};

export const useDeliveryContext = ({
  viewId,
  routeIds
}: {
  viewId: string;
  routeIds: string[];
}) => {
  return useQuery({
    queryKey: [viewId, "DELIVERY_CONTEXT"],
    queryFn: () => getDeliveryContext(routeIds),
    enabled: !!viewId && !!routeIds.length,
    retry: false
  });
};
